export const List = () => import("./List.vue");
export const Show = () => import("./Show.vue");
